import { useState } from 'react';
import { Card, Button, Badge, Modal, Input } from '@getpay93/ui';
import { usePlans, useCreatePlan, useUpdatePlan } from '../../data/hooks';
import { money } from '../../lib/format';

export function Planes() {
  const plans = usePlans();
  const create = useCreatePlan();
  const update = useUpdatePlan();
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [billingDay, setBillingDay] = useState('');

  function openCreate() { setEditId(null); setName(''); setPrice(''); setBillingDay(''); setOpen(true); }
  function openEdit(p: { id: string; name: string; price: number; billingDay?: number }) { setEditId(p.id); setName(p.name); setPrice(String(p.price)); setBillingDay(String(p.billingDay ?? 1)); setOpen(true); }

  function save() {
    const body = { name, price: Number(price), billingDay: Number(billingDay) };
    if (editId) update.mutate({ id: editId, body }, { onSuccess: () => setOpen(false) });
    else create.mutate(body, { onSuccess: () => setOpen(false) });
  }

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 14 }}>
        {(plans.data ?? []).map((p) => (
          <Card key={p.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
              <strong style={{ color: 'var(--text-strong)' }}>{p.name}</strong>
              {p.isActive === false ? <Badge tone="neutral">Archivado</Badge> : null}
            </div>
            <div style={{ fontSize: 26, fontWeight: 800, color: 'var(--brand-green)', margin: '8px 0' }}>{money(p.price)}</div>
            <div style={{ fontSize: 13, color: 'var(--text-hint)' }}>Cobro día {p.billingDay ?? '—'}</div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <Button size="sm" variant="ghost" onClick={() => openEdit(p)}>Editar</Button>
              {p.isActive !== false ? <Button size="sm" variant="ghost" onClick={() => update.mutate({ id: p.id, body: { isActive: false } })}>Archivar</Button> : null}
            </div>
          </Card>
        ))}
        <button onClick={openCreate} style={{ border: '2px dashed var(--border-strong)', borderRadius: 16, background: 'transparent', color: 'var(--text-faint)', cursor: 'pointer', minHeight: 140, fontFamily: 'var(--font-sans)', fontWeight: 700 }}>+ Crear plan</button>
      </div>

      {open ? (
        <Modal open onClose={() => setOpen(false)} title={editId ? 'Editar plan' : 'Crear plan'} footer={<><Button variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button><Button disabled={!name || !price || !billingDay} onClick={save}>Guardar</Button></>}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Input placeholder="Nombre del plan" value={name} onChange={(e) => setName(e.currentTarget.value)} />
            <Input placeholder="Precio" type="number" value={price} onChange={(e) => setPrice(e.currentTarget.value)} />
            <Input placeholder="Día de cobro (1-28)" type="number" value={billingDay} onChange={(e) => setBillingDay(e.currentTarget.value)} />
          </div>
        </Modal>
      ) : null}
    </div>
  );
}
